// shows a form for a user to add input
import _ from 'lodash';
import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import './MapFilter.css';

// const MAX_CONTRIBUTORS = 6;
const ASYNC_DELAY = 500;

class MapFilter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            multi: true,
            value: null
        };

        this.styles = {
        };
    }

	onChange (value) {
        /**
         * this is where we can build a state of the filters
         * we will use this filter state in other components
         * such as the propject map component
         */
		this.setState({
			value: value,
		});
        this.props.updateFilters(value);

        /**
         * parse a list of filters and extract categoryId's
         */
        var categories = [];
        if (value.length <= 0) {
            categories = _.map(this.props.filters.categories, 'categoryId');
        } else {
            categories = _.map(value, 'categoryId');
        }
        const values = {
            type : [
                "donate"
            ],
            categories : categories
        }
        this.props.filteredSearch(values);
    }

	getContributors (input, callback) {
		input = input.toLowerCase();
		var options = this.props.filters.categories.filter(i => {
			return i.categoryId.substr(0, input.length) === input;
		});
		var data = {
			// options: options.slice(0, MAX_CONTRIBUTORS),
			// complete: options.length <= MAX_CONTRIBUTORS,
			options: options,
			complete: options.length,
        };
		setTimeout(function() {
			callback(null, data);
		}, ASYNC_DELAY);
    }

	// gotoContributor (value, event) {
	// 	window.open('https://github.com/' + value.value);
    // }

    render() {
        /**
         * need to wait until a list of categories is returned by the redux store
         */
        if (this.props.filters.categories <= 0) {
            return (
                <div className="map-filter tikki-shadow-flat"></div>
            )
        }

        return (
            <div className="map-filter tikki-shadow-flat">
                <div className="map-filter-txt">I care about</div>
                <Select.Async
                    multi={this.state.multi}
                    value={this.props.filters.filters}
                    onChange={this.onChange.bind(this)}
                    // onValueClick={this.gotoContributor.bind(this)}
                    valueKey="categoryId"
                    labelKey="title"
                    loadOptions={this.getContributors.bind(this)}
                    className="map-filter-list"
                    backspaceToRemoveMessage=""
                    autosize={true}
                />
            </div>
        );
    }
}

function mapStateToProps({ filters }) {
    return {
        filters
    };
}

export default connect(mapStateToProps, actions)(MapFilter);



// WEBPACK FOOTER //
// ./src/components/Filters/MapFilter.js